<template>
    <div class="parking-filter-projects">
        <div class="container">
            <div class="filter-container" v-click-outside="onClickOutside" :class="{'openMobile': isOpenFilterMobile}">
                <div class="mobile-filter-header" v-if="isMobileChecker">
                    <h2><span>{{ filterCMSparams.words_translation.filter_title_filter_mobile }}</span></h2>
                    <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                </div>
                <div class="btn-find-info" v-if="isMobileChecker">
                    <a href="#" @click.prevent="closeMobileFilter">
                        <parkingFindNum class="btn-find"></parkingFindNum>
                    </a>
                </div>
                <div class="top-items">
                    <!-- FILTER COMPLEX -->
                    <div class="dropwdown-filter-select dropwdown-complex">
                        <div class="drop-filter-name" :class="{'open' : open_dropComplex}">
                            <a href="#" @click.prevent="open_dropComplex = !open_dropComplex, open_dropPart = false, open_dropClass = false">{{filterCMSparams.parking_filter.sales.name}}</a>
                            <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : open_dropComplex}">
                            <div class="mobile-filter-drop-header" v-if="isMobileChecker">
                                <a href="#" class="close-arrow" @click.prevent="open_dropComplex = !open_dropComplex"><svgIcon name="arrow-drop" class="icon-svg"/></a>
                                <h2>{{filterCMSparams.parking_filter.sales.name}}</h2>
                                <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                            </div>
                            <div class="drop-checkbox-container">
                                <div class="item-R" v-for="item in filterCMSparams.parking_filter.sales.sales_list">
                                    <input type="checkbox" :id="item.slug" :value="item.slug" v-model="filterParkingDataBase.complexChecked" @change="filterSalesItems()"> 
                                    <label :for="item.slug">{{item.name}}</label>
                                </div>
                            </div>
                            <div class="btn-save" v-if="isMobileChecker">
                                <a href="#" @click.prevent="open_dropComplex = !open_dropComplex"><span>{{ filterCMSparams.words_translation.filter_btn_save_mobile }}</span></a>
                            </div>
                        </div>
                    </div>
                    <!-- END FILTER COMPLEX -->
                    <!-- FILTER PARTS -->
                    <div class="dropwdown-filter-select dropwdown-part">
                        <div class="drop-filter-name" :class="{'open' : open_dropPart}">
                            <a href="#" @click.prevent="open_dropPart = !open_dropPart, open_dropComplex = false, open_dropClass = false">{{filterCMSparams.parking_filter.parts.name}}</a>
                            <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : open_dropPart}">
                            <div class="mobile-filter-drop-header" v-if="isMobileChecker">
                                <a href="#" class="close-arrow" @click.prevent="open_dropPart = !open_dropPart"><svgIcon name="arrow-drop" class="icon-svg"/></a>
                                <h2>{{filterCMSparams.parking_filter.parts.name}}</h2>
                                <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                            </div>
                            <div class="drop-checkbox-container" v-if="globalLang != 'kz/'">
                                <div class="item-R" v-for="item in filterCMSparams.parking_filter.parts.parts_list">
                                    <input type="checkbox" :id="item.value" :value="item.value" v-model="filterParkingDataBase.partsChecked" @change="filterSalesItems()"> 
                                    <label :for="item.value">{{item.label}}</label>
                                </div>
                            </div>
                            <div class="drop-checkbox-container" v-if="globalLang == 'kz/'">
                                <div class="item-R" v-for="item in filterCMSparams.parking_filter.parts.parts_list_kz">
                                    <input type="checkbox" :id="item.value" :value="item.value" v-model="filterParkingDataBase.partsChecked" @change="filterSalesItems()"> 
                                    <label :for="item.value">{{item.label}}</label>
                                </div>
                            </div>
                            <div class="btn-save" v-if="isMobileChecker">
                                <a href="#" @click.prevent="open_dropPart = !open_dropPart"><span>{{ filterCMSparams.words_translation.filter_btn_save_mobile }}</span></a>
                            </div>
                        </div>
                    </div>
                    <!-- END FILTER PARTS -->
                    <!-- FILTER PARTS -->
                    <div class="dropwdown-filter-select dropwdown-class">
                        <div class="drop-filter-name" :class="{'open' : open_dropClass}">
                            <a href="#" @click.prevent="open_dropClass = !open_dropClass, open_dropComplex = false, open_dropPart = false">{{filterCMSparams.parking_filter.type.name}}</a>
                            <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : open_dropClass}">
                            <div class="mobile-filter-drop-header" v-if="isMobileChecker">
                                <a href="#" class="close-arrow" @click.prevent="open_dropClass = !open_dropClass"><svgIcon name="arrow-drop" class="icon-svg"/></a>
                                <h2>{{filterCMSparams.parking_filter.type.name}}</h2>
                                <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                            </div>
                            <div class="drop-checkbox-container">
                                <div class="item-R" v-for="item in filterCMSparams.parking_filter.type.types_list">
                                    <input type="checkbox" :id="item.value" :value="item.value" v-model="filterParkingDataBase.classChecked" @change="filterSalesItems()"> 
                                    <label :for="item.value">{{getCorrectSTRword(item.label)}}</label>
                                </div>
                            </div>
                            <div class="btn-save" v-if="isMobileChecker">
                                <a href="#" @click.prevent="open_dropClass = !open_dropClass"><span>{{ filterCMSparams.words_translation.filter_btn_save_mobile }}</span></a>
                            </div>
                        </div>
                    </div>
                    <!-- END FILTER PARTS -->
                    <div class="dropwdown-filter-select dropwdown-btns" v-if="!isMobileChecker">
                        <div class="drop-checkbox-single">
                            <div class="item-check">
                                <input type="checkbox" id="electro_btn" v-model="filterParkingDataBase.electro" @change="filterSalesItems()"> 
                                <label for="electro_btn">{{filterCMSparams.parking_filter.electro_btn_desc}}</label>
                            </div>
                            <div class="item-check">
                                <input type="checkbox" id="actions_btn" v-model="filterParkingDataBase.actions" @change="filterSalesItems()"> 
                                <label for="actions_btn">{{filterCMSparams.parking_filter.sales_btn_desc}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom-items">
                    <!-- RANGE SIZE -->
                    <div class="drop-filter-item drop-filter-size">
                        <span>{{filterCMSparams.parking_filter.size.name}}</span>
                        <div class="filter size-filter range-filter" v-if="filterParkingDataBase.initRangeSliders">
                            <div class="filter-inputs filter-inputs-size">
                                <div class="input-item">
                                    <span class="start">от</span>
                                    <input type="number" name="minSize" class="form-control" v-model.lazy="filterParkingDataBase.size[0]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">м²</span>
                                </div>
                                <div class="input-item">
                                    <span class="start">до</span>
                                    <input type="number" name="maxSize" class="form-control" v-model.lazy="filterParkingDataBase.size[1]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">м²</span>
                                </div>
                            </div>
                            <!-- @change="filterSalesItems()" -->
                            <div class="parking-filter-range-slider">
                                <div class="filter" id="SizeFilter">
                                    <input type="text" id="size-filter" name="size"  class="ionRangeSlider" value="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- RANGE PRICE -->
                    <div class="drop-filter-item drop-filter-price">
                        <span>{{filterCMSparams.parking_filter.price.name}}</span>
                        <div class="filter size-filter range-filter" v-if="filterParkingDataBase.initRangeSliders">
                            <div class="filter-inputs filter-inputs-size">
                                <div class="input-item">
                                    <span class="start">от</span>
                                    <input type="number" name="minPrice" class="form-control" v-model.lazy="filterParkingDataBase.price[0]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">млн</span>
                                </div>
                                <div class="input-item">
                                    <span class="start">до</span>
                                    <input type="number" name="maxPrice" class="form-control" v-model.lazy="filterParkingDataBase.price[1]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">млн</span>
                                </div>
                            </div>
                            <!-- @change="filterSalesItems()" -->
                            <div class="parking-filter-range-slider">
                                <div class="filter" id="PriceFilter">
                                    <input type="text" id="price-filter" name="size"  class="ionRangeSlider" value="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="drop-filter-item drop-filter-btns">
                        <span>{{filterCMSparams.parking_filter.level.name}}</span>
                        <div class="filter level-items">
                            <div class="item-R" v-for="item in filterCMSparams.parking_filter.level.level">
                                <input type="checkbox" :id="'level_' + item" :value="item" v-model="filterParkingDataBase.levelQuantities" @change="filterSalesItems()">
                                <label :for="'level_' + item">{{item}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="drop-filter-item dropwdown-btns" v-if="isMobileChecker">
                        <div class="drop-checkbox-single">
                            <div class="item-check">
                                <input type="checkbox" id="electro_btn" v-model="filterParkingDataBase.electro" @change="filterSalesItems()"> 
                                <label for="electro_btn">{{filterCMSparams.parking_filter.electro_btn_desc}}</label>
                            </div>
                            <div class="item-check">
                                <input type="checkbox" id="actions_btn" v-model="filterParkingDataBase.actions" @change="filterSalesItems()"> 
                                <label for="actions_btn">{{filterCMSparams.parking_filter.sales_btn_desc}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="drop-filter-item drop-filter-reset" v-if="!isMobileChecker">
                        <div class="btn-reset-filter" @click="reloadFilter">
                            <span>{{ filterCMSparams.words_translation.filter_btn_clearfilter }}</span>
                            <svgIcon name="close-filter" class="icon-close"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mobile-filter-container" v-if="isMobileChecker">
                <div class="mobile-filter-btns">
                    <a href="#" @click.prevent="openMobileFilter">
                        <span>{{ filterCMSparams.parking_filter.btn_filter_mobile_name }}</span>
                        <svgIcon name="filter" class="icon-svg"/>
                    </a>
                    <a href="#" @click.prevent="openMobileShorting" class="shorting-link" v-if="shortingParam != null">
                        <div class="short-icon">
                            <svgIcon name="shorting-up" class="icon-up" v-if="shortingParam.type == 'ascending'"/>
                            <svgIcon name="shorting-down" class="icon-down" v-if="shortingParam.type == 'descending'"/>
                        </div>
                        <span>{{ shortingParam.name }}</span>
                        <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                    </a>
                    <div class="down-btns">
                        <parkingViewBtns></parkingViewBtns>
                        <div class="btn-reset-filter-mobile" @click="reloadFilter">
                            <span>{{ filterCMSparams.words_translation.filter_btn_clearfilter }}</span>
                            <svgIcon name="close-filter" class="icon-close"/>
                        </div>
                    </div>
                </div>
                <div class="btns-bottom-controls">
                    <parkingFindNum></parkingFindNum>
                </div>
            </div>
            <parkingShorting class="mobile-shorting" :class="{'open' : isOpenShortingMobile}" v-if="isMobileChecker && shortingParam != null && parkingItems != null"></parkingShorting>
        </div>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import parkingShorting from '@/components/filters/parking-filter/shorting-filter.vue'
    import parkingViewBtns from '@/components/parking-page/parking-view-btns.vue'
    import parkingFindNum from '@/components/parking-page/parking-find-num.vue'
    // import salesFilterCount from '@/components/filters/sales-projects/sales-filter-counter.vue'
    // import simplebar from 'simplebar-vue';
    // import VueSlider from 'vue-slider-component'
    // import 'vue-slider-component/theme/antd.css'
    // import 'simplebar-vue/dist/simplebar.min.css';
    import {mapGetters} from 'vuex'
    export default {
        name: 'parking-filter-projects',
        components: {
            svgIcon,
            parkingShorting,
            parkingViewBtns,
            parkingFindNum,
            // simplebar,
            // VueSlider,
            // salesFilterCount,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                routerName: this.$router.history.current.name,
                open_dropComplex: false,
                open_dropPart: false,
                open_dropClass: false,
                SizeFilter: null,
                PriceFilter: null,
            }
        },
        computed: mapGetters({
            parkingItems: 'loadParkingItems',
            parkingItemsDefault: 'loadParkingItemsDefault',
            isMobileChecker: 'loadIsMobileChecker',
            filterCMSparams: 'loadFilterCMSparams',
            filterParkingDataBase: 'loadFilterParkingData',
            isOpenFilterMobile: 'loadOpenParkingMobileFilter',
            isOpenShortingMobile: 'loadOpenParkingMobileShorting',
            shortingParam: 'loadParkingShortingParams',
        }),
        methods: {
            setDataInSalesDataBase(param, data) {
                this.$store.commit('FilterParking_update_base', {name: param, data: data});
                this.filterSalesItems();
            },
            onClickOutside() {
                this.open_dropComplex = false;
                this.open_dropPart = false;
                this.open_dropClass = false;
            },
            validateInput(e) {
                const minSize_default = parseInt(this.filterCMSparams.parking_filter.size.min);
                const maxSize_default = parseInt(this.filterCMSparams.parking_filter.size.max);
                const minPrice_default = parseInt(this.filterCMSparams.parking_filter.price.min);
                const maxPrice_default = parseInt(this.filterCMSparams.parking_filter.price.max);
                // console.log(e.target.value, e.target.name, this.filterParkingDataBase.size[1]);
                //--// -- CHECK FOR SIZE FILTER RANGE
                if (e.target.name == 'minSize') {
                    if (parseInt(e.target.value) < minSize_default) {
                        e.target.value = minSize_default;
                        this.$store.commit('FilterParking_update_base', {name: 'sizeUpdate', param: 'min', data: minSize_default});
                    } else if (parseInt(e.target.value) > this.filterParkingDataBase.size[1]) {
                        e.target.value = this.filterParkingDataBase.size[1];
                        this.$store.commit('FilterParking_update_base', {name: 'sizeUpdate', param: 'min_max', data: this.filterParkingDataBase.size[1]});
                    }
                } else if (e.target.name == 'maxSize') {
                    if (parseInt(e.target.value) > maxSize_default) {
                        e.target.value = maxSize_default;
                        this.$store.commit('FilterParking_update_base', {name: 'sizeUpdate', param: 'max', data: maxSize_default});
                    } else if (parseInt(e.target.value) < this.filterParkingDataBase.size[0]) {
                        e.target.value = this.filterParkingDataBase.size[0];
                        this.$store.commit('FilterParking_update_base', {name: 'sizeUpdate', param: 'max_max', data: this.filterParkingDataBase.size[0]});
                    }
                } 
                //--//-- CHECK FOR PRICE FILTER RANGE
                else if (e.target.name == 'minPrice') {
                    if (parseInt(e.target.value) < minPrice_default) {
                        e.target.value = minPrice_default;
                        this.$store.commit('FilterParking_update_base', {name: 'priceUpdate', param: 'min', data: minPrice_default});
                    } 
                    else if (parseInt(e.target.value) > this.filterParkingDataBase.price[1]) {
                        e.target.value = this.filterParkingDataBase.price[1];
                        this.$store.commit('FilterParking_update_base', {name: 'priceUpdate', param: 'min_max', data: this.filterParkingDataBase.price[1]});
                    } 
                }
                else if (e.target.name == 'maxPrice') {
                    if (parseInt(e.target.value) > maxPrice_default) {
                        e.target.value = maxPrice_default;
                        this.$store.commit('FilterParking_update_base', {name: 'priceUpdate', param: 'max', data: maxPrice_default});
                    } else if (parseInt(e.target.value) < this.filterParkingDataBase.price[0]) {
                        e.target.value = this.filterParkingDataBase.price[0];
                        this.$store.commit('FilterParking_update_base', {name: 'priceUpdate', param: 'max_max', data: this.filterParkingDataBase.price[0]});
                    }
                }

                this.updateIONrangeSlider();
                this.filterSalesItems();
            },
            BuildIonRangeSlider() {
                var _self = this;
                // console.log(_self.filterMinMaxParams, '212312312123123')
                _self.SizeFilter = $('#size-filter');
                _self.PriceFilter = $('#price-filter');
                _self.SizeFilter.ionRangeSlider({
                    type: "double",
                    min: parseInt(_self.filterCMSparams.parking_filter.size.min),
                    max: parseInt(_self.filterCMSparams.parking_filter.size.max),
                    from: _self.filterParkingDataBase.size[0],
                    to: _self.filterParkingDataBase.size[1],
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterParking_update_base', {name: 'sizeUpdate', param: 'rangeSlider', data: {min: data.from, max: data.to}})
                        _self.filterSalesItems(); 
                    },
                    // onUpdate: function (data) {
                    //     // console.log(data, 'update')
                    //     _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                    //     // _self.updateFilterDataBase();
                    // },
                });
                _self.PriceFilter.ionRangeSlider({
                    type: "double",
                    min: parseInt(_self.filterCMSparams.parking_filter.price.min),
                    max: parseInt(_self.filterCMSparams.parking_filter.price.max),
                    from: _self.filterParkingDataBase.price[0],
                    to: _self.filterParkingDataBase.price[1],
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterParking_update_base', {name: 'priceUpdate', param: 'rangeSlider', data: {min: data.from, max: data.to}})
                        _self.filterSalesItems(); 
                        // _self.updateFilterDataBase(); 
                    },
                    // onUpdate: function (data) {
                    //     // console.log(data, 'update')
                    //     _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                    //     // _self.updateFilterDataBase();
                    // },
                });

            },
            // сброс всех range фильтров при динамических изменения данных мимальных и максимальных значениях фильтра
            updateIONrangeSlider() {
                var _self = this;
                _self.SizeFilter.data("ionRangeSlider").update({
                    from: _self.filterParkingDataBase.size[0],
                    to: _self.filterParkingDataBase.size[1],
                });
                _self.PriceFilter.data("ionRangeSlider").update({
                    from: _self.filterParkingDataBase.price[0],
                    to: _self.filterParkingDataBase.price[1],
                });
            },
            resetIONrangeSlider() {
                var _self = this;
                _self.SizeFilter.data("ionRangeSlider").update({
                    min: parseInt(_self.filterCMSparams.parking_filter.size.min),
                    max: parseInt(_self.filterCMSparams.parking_filter.size.max),
                    from: parseInt(_self.filterCMSparams.parking_filter.size.min),
                    to: parseInt(_self.filterCMSparams.parking_filter.size.max),
                });
                _self.PriceFilter.data("ionRangeSlider").update({
                    min: parseInt(_self.filterCMSparams.parking_filter.price.min),
                    max: parseInt(_self.filterCMSparams.parking_filter.price.max),
                    from: parseInt(_self.filterCMSparams.parking_filter.price.min),
                    to: parseInt(_self.filterCMSparams.parking_filter.price.max),
                });
            },
            filterSalesItems() {
                var parkingItems = this.parkingItemsDefault;
                const filteredData = parkingItems.filter(item => {
                    return (!this.filterParkingDataBase.complexChecked.length || this.filterParkingDataBase.complexChecked.includes(item.project.slug)) &&
                           (!this.filterParkingDataBase.partsChecked.length || this.filterParkingDataBase.partsChecked.includes(item.part.value)) &&
                           (!this.filterParkingDataBase.classChecked.length || this.filterParkingDataBase.classChecked.includes(item.type.value)) &&
                           (!this.filterParkingDataBase.levelQuantities.length || this.filterParkingDataBase.levelQuantities.includes(item.level)) &&
                           (parseFloat(item.size) >= this.filterParkingDataBase.size[0] && parseFloat(item.size) <= this.filterParkingDataBase.size[1]) &&
                           (parseFloat(item.price) >= this.filterParkingDataBase.price[0] && parseFloat(item.price) <= this.filterParkingDataBase.price[1]) &&
                           (this.filterParkingDataBase.electro === false ? true : item.electro == this.filterParkingDataBase.electro) &&
                           (this.filterParkingDataBase.actions === false ? true : item.sales_init == this.filterParkingDataBase.actions)
                });
                // console.log(filteredData)
                this.$store.commit('setParkingItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : filteredData});
            },
            reloadFilter() {
                this.$store.commit('setParkingItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : this.parkingItemsDefault});
                this.$store.commit('ReloadParkingFilter');
                this.resetIONrangeSlider();
                // this.filterSalesItems();
            },  
            openMobileFilter() {
                this.$store.commit('OpenParkingMobileFilter', true);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('hideMobile');
                document.getElementById('footer').classList.add('hideMobile');
            },
            closeMobileFilter() {
                this.$store.commit('OpenParkingMobileFilter', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementById('header').classList.remove('hideMobile');
                document.getElementById('footer').classList.remove('hideMobile');
            },
            openMobileShorting() {
                this.$store.commit('OpenParkingMobileShorting', true);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('hideMobile');
                document.getElementById('footer').classList.add('hideMobile');
            },
            getCorrectSTRword(str) {
                if (this.globalLang != 'kz/') {
                    return str;
                } else {
                    if (str == 'Стандартное') {
                        return 'Стандарт';
                    } else if (str == 'VIP') {
                        return str;
                    } else if (str == 'Зависимое') {
                        return 'Тәуелді';
                    } else if (str == 'Откатное') {
                        return 'Жылжымалы';
                    } else if (str == 'Среднее') {
                        return 'Орташа';
                    } else if (str == 'Малое') {
                        return 'Шағын';
                    } else if (str == 'Большое') {
                        return 'Үлкен'
                    }
                }
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.BuildIonRangeSlider();
            this.$store.commit('setParkingShortingParams', this.filterCMSparams.shorting_names.price_up);
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/filters/parking-filter/parking-filter.scss';
    @import '@/styles/components/filters/parking-filter/respond/parking-filter-respond.scss';
    // @import '@/styles/components/filters/sales-projects/respond/sales-filter-respond.scss';
</style>